import {Injectable} from '@angular/core';
import {LoggerService} from './logger.service';

export class ErrorCode {
    constructor(public msg: string, public code?: number) {
        ;
    }
}

@Injectable()
export class UtilService {

    constructor(private logger: LoggerService) {
    }

    httpError(err: any): ErrorCode {
        this.logger.log('UtilService:', err);
        this.logger.log('UtilService: err[headers]', err['headers']);

        if (err['headers'] &&
            err['headers'].get &&
            err['headers'].get('Content-Type') === 'application/json;charset=UTF-8') {
            // json response
            let resp = err.error;
            /*HttpErrorResponse*/
            // error message
            if (resp.error) {
                return new ErrorCode(resp.error);
            }
            // system error
            if (resp.code && resp.message) {
                return new ErrorCode(resp.message);
            }
        }

        switch (err['status']) {
            case 503:
                return new ErrorCode('Service is Temporarily Unavailable.', err['status']);
            case 200:
            case 0: // status is 0 when logged in behind CAS (at least Safari case)
                if (err['status'] === 0 || err.url == null || (err.url || '').match(/https?:\/\/cas\./g)) {
                    // redirect to cas
                    return new ErrorCode('Your session has expired. Please refresh the page.', err['status']);
                }
                break;
            case 403:
                return new ErrorCode('Access to this URL is denied.', err['status']);
        }
        return new ErrorCode('Received error status ' + err['status'] + '.', err['status']);
    }
}
